// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationFeaturesText-cls1_vrp","cls2":"TranslationFeaturesText-cls2_Hzs TranslationFeaturesText-cls1_vrp"};